

import { Component, OnInit, ViewChild } from '@angular/core';
import { Platform, ModalController, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService, MessageclientService, NativeService } from 'src/service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/service/common.service';
import { BaseCase } from 'src/app/basecase';
import { BaseModal } from 'src/model';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from 'src/model/common';
import { GiftAuditModalPage } from 'src/app/page/nestle/gift-audit-modal/gift-audit-modal.page';
declare var app;
@Component({
  selector: 'app-gift-audit-detail',
  templateUrl: './gift-audit-detail.component.html',
  styleUrls: ['./gift-audit-detail.component.scss']
})
export class GiftAuditDetailComponent extends GridBaseCase {
  tabsIndex: any = 0;
  remarkvalue: any; //信息反馈字段
  outOrInType: string;//调出或者调入类型type
  outOrInName: string;
  pageName: string = null;
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  dataArrayList: Array<any> = [];//数据列表
  current_obj: any = {};//当前对象
  giftsCategoryID: any; // 产品分类的id
  arrayDatalist: Array<any> = [];
  _tempArray: Array<any> = [];
  imgUrlArr: Array<any> = [];
  remark:any="";//备注
  arrayData: Array<any> = [];
  pageNameone: number = 0; // 产品所属于产品
  ID: string = "";
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private route: ActivatedRoute,
    private msg: MessageclientService,
    private com: CommonService,
    private native: NativeService,
    public baseService: BaseCase,
    public base: BaseModal,
    public modal: ModalController,
  ) {
    super();
    this.baseService.arrayData = [];
    // this.getProductList();
    const ImgPreview = this.route.snapshot.queryParamMap.get("JsonData");

    this.current_obj = JSON.parse(ImgPreview);
    if (this.current_obj && this.current_obj.ID) {
      this.ID = this.current_obj.ID || "";
    }
    if(this.current_obj.SignTimeEffect){
      this.current_obj.SignTimeEffect=this.current_obj.SignTimeEffect.replace(/-/g,"/").replace("T"," ");
    }
    if(this.current_obj.MessageFeedback){
      this.remark=this.current_obj.MessageFeedback;
    }
    if (this.current_obj && this.current_obj.ImgUrl) {
      this.current_obj.ImgUrl.split(",").forEach(item => {
        let _url: string = (app.FileUoloadUrl + item).replace(app.ImagePlaceholder, app.SmallImageType);
        console.log(_url, "文件地址路径");
        this.imgUrlArr.push({ url: _url, name: item, "isUpload": true });
      });
    }

    this.baseService.FixedSubmitBtn.configName = "GiftAuditDetail";
    this.baseService.FixedSubmitBtn.isShow = true;
    this.baseService.FixedSubmitBtn.type = 19;
    this.LoadData(1);
  }
  //提交按钮
  //提交按钮
  EventSubmitClick(btnType: any = true) {
    var that = this;
    if (btnType) {
      console.log("GiftAuditList 通过");
    } else {
      console.log("GiftAuditList  拒绝");
    }
    console.log("提交 json", this.baseService.arrayData);
    console.log("提交 json", this.dataArrayList);
    let curr_list = [];
    let bohui_list = [];
    let curr_obj = {};
    let bohui_obj = {};
    curr_obj["FK_TBGiftQuota_ID"] = that.ID || "";
    if (that.current_obj && that.current_obj.FK_TBStore_ID) {
      curr_obj["FK_TBStore_ID"] = that.current_obj.FK_TBStore_ID || "";
    }
    curr_list.push(curr_obj);

    //拒绝只穿id 不传  tbstoreid
    bohui_obj["FK_TBGiftQuota_ID"] = that.ID || "";
    bohui_list.push(bohui_obj);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;

    body.ConfigName = "TBGiftQuotExamine";
    body.OpType = "edite";
    body.ConfigType = "form";
    body.RowsPerPage = 1000;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let typeObj = {};
    if (!btnType) {
      //拒绝走另一个接口
      // typeObj["ExamineState"] = btnType ? 1 : 2;
      //ids 一个id 时 为0，多个为1
      typeObj["whetherSingle"] = curr_list.length > 1 ? 1 : 0;

      typeObj["giftQuotaListID"] = bohui_list;
      body.ConfigName = "TBGiftQuotReject";
      that.presentModal(body, typeObj);
    } else {
      // typeObj["ExamineState"] = btnType ? 1 : 2;
      //ids 一个id 时 为0，多个为1
      typeObj["whetherSingle"] = curr_list.length > 1 ? 1 : 0;

      typeObj["giftQuotaListID"] = curr_list;
      console.log("提交 json", typeObj);
      that.Submit(body, typeObj);
    }

  }

  async presentModal(body: any = new WebParameterContext(), requestObj: any) {
    const modal = await this.modal.create({
      component: GiftAuditModalPage,
      cssClass: 'my-custom-class',
      componentProps: {
        'configName': this.pageName,
      }
    });

    await modal.present();
    const { data } = await modal.onWillDismiss();
    if (data && data.request) {
      let remark = data["result"] || "";
      console.log("modalww", this.baseService.arrayData);
      requestObj["dismissReason"] = remark;
      this.Submit(body, requestObj);
      console.log("submit", requestObj);
    } else {
      return;
    }
  }


  Submit(body, typeObj) {
    const that = this;
    console.log("提交 json", typeObj);
    body.RequestBody = JSON.stringify(typeObj);
    that.msg.Loading("请稍后...").then(loads => {
      that.http.post(app.DEFAULTURL, body).then(data => {
        setTimeout(function () {
          loads.dismiss();
        }, 100);
        if (data.ResponseMessage.Success) {
          that.msg.Alert("操作成功！");
          this.com.goBack();
        } else {
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
      }).catch(err => {
        loads.dismiss();
        that.msg.Alert("网络异常，请稍后再试！");
      });

    })
  }


  ngOnInit() {
  }


  // tab切换
  ipcConten(item, num) {
    const that = this;
    that.tabsIndex = num;
    that.giftsCategoryID = item.GiftsCategoryID;
    that.LoadDataone(1);

  }

  //  右边详情数据
  loadMoreDataone(event) {
    let that = this;
    that.pageNameone++;
    that.LoadDataone(that.pageNameone);
  }

  LoadDataone(pageNameone) {
    console.log(this.giftsCategoryID, "默认产品分类id");
    let that = this;
    if (that.arrayDatalist.length > 0) {
      if (that._tempArray.length <= 0) {
        that._tempArray = that.arrayDatalist;
      } else {
        //如果缓存里面存在当前类别的数据则更新缓存数据未最新结果
        that.arrayDatalist.forEach(item => {
          if (that._tempArray.find(ks => ks.GiftsCategoryID == item.GiftsCategoryID)) {
            that._tempArray.forEach(items => {
              if (item.ID == items.ID) {
                items = item;
              }
            });
          } else {
            that._tempArray.push(item);
          }
        });

      }
    }
    //如果缓存包含当前数据则读取缓存数据
    if (that._tempArray.find(sc => sc.GiftsCategoryID == that.giftsCategoryID)) {
      that.arrayDatalist = that._tempArray.filter(sc => sc.GiftsCategoryID == that.giftsCategoryID);
      return;
    }
    that.pageNameone = pageNameone;
    if (pageNameone == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    let _dy: any = {
      "FK_TBGiftQuota_ID": that.ID,
      "GiftsCategoryID": that.giftsCategoryID
    };
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const pageid = that.activaRouter.snapshot.paramMap.get('id');
    let body = new WebParameterContext();
    body.ConfigName = "TBGiftQuotaCategoryDetailXML";
    body.OpType = "query";
    body.ConfigType = "view";
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.ClientType = 2;
    body.Client.Name = "product";
    body.RequestBody = JSON.stringify(_dy);
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        that.arrayDatalist = data.Status.Datas;

        that.arrayDatalist.forEach(item => {
          item.ChineseName = that.com.FormatName(item.ChineseName || "");
          item.Mobile = that.com.PhoneNum(item.Mobile || "");
        });
        if (that._tempArray.length <= 0) {//如果第一次加载则赋值到数组里面
          that._tempArray = that.arrayDatalist;
        }
      }
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }




  RemarkInput(e) {
    let that = this;
    if (e && e.target.value) {
      if (e.target.value.length > 120) {
        e.target.value = e.target.value.substr(0, 120);
        that.remarkvalue = e.target.value;
      }
    }
  }

  loadMoreData(event) {
    let that = this;
    that.PageNumber++;
    that.LoadData(that.PageNumber);
  }
  LoadData(PageNumber) {
    let that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    let _dy: any = {
      "FK_TBGiftQuota_ID": that.ID
    };
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const pageid = that.activaRouter.snapshot.paramMap.get('id');
    let body = new WebParameterContext();
    body.ConfigName = "TBGiftQuotaDetailXML";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = 15;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.ClientType = 2;
    body.Client.Name = "product";
    body.RequestBody = JSON.stringify(_dy);
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        that.arrayData = data.Status.Datas;
        if (that.arrayData.length > 0) {
          that.giftsCategoryID = that.arrayData[0].GiftsCategoryID;
          that.LoadDataone(1);
        }
      };

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }
    /**
   * 
   * @param i 查看照片
   */
  imgPreviewClick(i) {
    let that = this;
    let url = [];
    that.imgUrlArr.forEach(item=>{
      let u = null;
      if(item.url.indexOf("data:") > -1){
        u = item.url
      }else{
        u = item.url.trim().replace(app.SmallImageType,app.BigImageType);
      }
      url.push(u);
    })
    let Preview = {
      imgUrl: url,
      index: i
    }
    that.com.setHistoryUrl(false);
    // localStorage.setItem("ImgPreview",JSON.stringify(ImgPreview));
    // that.router.navigate(["/tabs/contact/ImgPreview"]);
    that.com.Go("/tabs/contact/ImgPreview/"+that.com.getNowDatetime,{
      ImgPreview: JSON.stringify(Preview)
    });
  }


}
